<template>
  <div
    v-if="offerData?.productSaleInfo?.priceRangeList?.length >= 2"
    class="h5-interval"
    :style="{
      'grid-template-columns': `repeat(${offerData?.productSaleInfo?.priceRangeList?.length > 3 ? 3 : offerData?.productSaleInfo?.priceRangeList?.length}, auto)`,
    }"
  >
    <div
      v-for="(item, index) in offerData?.productSaleInfo?.priceRangeList"
      class="h5-interval-item"
      :class="{ 'hidden-last-item-before': offerData?.productSaleInfo?.priceRangeList?.length < 3 }"
      :key="index"
    >
      <div class="interval-item-pcs">
        {{ item?.startQuantityStr }} PCS
      </div>
      <div
        class="interval-item-price"
      >
        <IntlCurrency
          :count="bankersRound(currencyData?.rate * item?.price, 2)"
          :size="14"
          :currency="currencyData?.targetCurrency.slice(0, 2)"
          color="#232323"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'
import { bankersRound } from '@/utils/utils'
import { useIntercom } from '@/hooks/useIntercom'

const skuLength = ref(0)

const props = defineProps({
  offerData: Object,
  currencyData: Object
})

const minPriceRange = ref([])

const intercom = useIntercom()

const offerData = computed(() => props.offerData || {})
const currencyData = computed(() => props.currencyData || {})

watch(
  () => offerData.value,
  (newData) => {
    if (newData) {
      skuLength.value = newData?.productSaleInfo?.priceRangeList?.length || 0
      handleMinPriceRange(newData)
    }
  }
)

const onContact = () => {
  intercom.showNewMessage()
}

const handleMinPriceRange = (data) => {
  const productSkuInfos = data.productSkuInfos
  if (!productSkuInfos) return
  let price = Number(productSkuInfos[0].price)
  productSkuInfos.forEach(item => {
    const p = Number(item.price)
    if (price > p) {
      price = p
    }
  })
  minPriceRange.value = [{
    startQuantityStr: '>=' + data.minOrderQuantity,
    price: price
  }]
}

onMounted(() => {
  handleMinPriceRange(offerData.value)
})
</script>

<style lang="less" scoped>
.h5-interval {
  display: grid;
  border-radius: 4px;
  margin-top: 12px;
  background-color: #eff4fd;
  padding: 4px 0;

  &.minPrice {
    width: 120px;
  }
  
  .h5-interval-item {
    position: relative;
    height: 50px;
    display: flex;
    gap: 2px;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    &.clearBefore {
      &::before {
        display: none;
      }
    }

    .interval-item-pcs {
      font-family: mon-500;
      font-size: 10px;
      color: #5c5c5c;
    }
    .interval-item-price {
      font-size: 14px;
      font-family: mon-700;
      color: #232323;
    }
  }
  .h5-interval-item::before {
    content: '';
    width: 0.5px;
    height: 32px;
    background-color: #B2B7C2;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
  .h5-interval-item:nth-child(3n)::before {
    display: none;
  }
  .hidden-last-item-before:last-child::before {
    display: none;
  }
}
</style>
